// Slice sync + polling. Logica identica a gmailStore.ts.
import type { MailAdapter } from '../mailAdapter';
import type { MailActions, MailSet, MailGet } from '../storeTypes';

export function createSyncSlice(
  set: MailSet,
  get: MailGet,
  adapter: MailAdapter,
): Pick<MailActions, 'syncInbox' | 'startPolling' | 'stopPolling' | 'setPollingSpeed'> {
  const LOG = `[mailStore:${adapter.provider}]`;
  return {
    syncInbox: async (organizationId, userId, fullSync = false) => {
      set({ syncStatus: 'syncing', syncError: null });
      try {
        const data = await adapter.sync(organizationId, userId, fullSync);

        if (data?.needs_full_sync) {
          // History ID expired, retry with full sync
          await get().syncInbox(organizationId, userId, true);
          return;
        }

        set({ syncStatus: 'idle', lastSyncAt: new Date().toISOString() });

        // Reload threads after sync
        await get().loadThreads(organizationId, userId);
      } catch (error: any) {
        console.error(`${LOG} Sync error:`, error);
        set({ syncStatus: 'error', syncError: error.message || 'Sync failed' });
      }
    },

    startPolling: (organizationId, userId, intervalMs = 300000) => {
      const existing = get()._pollingInterval;
      if (existing) clearInterval(existing);

      const interval = setInterval(() => {
        const state = get();
        if (state.syncStatus !== 'syncing') {
          state.syncInbox(organizationId, userId, false);
        }
      }, intervalMs);

      set({ _pollingInterval: interval });
    },

    stopPolling: () => {
      const interval = get()._pollingInterval;
      if (interval) {
        clearInterval(interval);
        set({ _pollingInterval: null });
      }
    },

    setPollingSpeed: (organizationId, userId, speed) => {
      get().stopPolling();
      // fast = 15s (drawer open), slow = 5min (drawer closed, badge only)
      get().startPolling(organizationId, userId, speed === 'fast' ? 15000 : 300000);
    },
  };
}
